// extracted by mini-css-extract-plugin
module.exports = {"ModalCloseSvg":"Close_ModalCloseSvg__1Qg6t"};